// @flow

import * as React from 'react';
import type { Node } from 'react';
import { push } from 'react-router-redux';
import { Route, Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import AceEditor from 'react-ace';

type MappedStatePropsType = {|
|};
type MappedDispatchPropsType = {|
|};
type OwnPropsType = {|
    path: string,
    title: string,
    children: Node,
    componentStringRepresentation: string,
    editorWidth?: string,
    editorHeight?: string
|};
type PropsType = MappedStatePropsType & MappedDispatchPropsType & OwnPropsType;

const ExampleRouteWrapper = ({ path, title, children, componentStringRepresentation, editorWidth, editorHeight }: PropsType): Node => {
    class Wrapper extends React.Component<{}> {
        render(): Node {
            return (
                <div>
                    <h1>{title}</h1>
                    <div className="code">
                        <AceEditor
                            mode="jsx"
                            theme="monokai"
                            name="UNIQUE_ID_OF_DIV"
                            editorProps={{ $blockScrolling: true }}
                            fontSize={14}
                            value={componentStringRepresentation}
                            height={editorHeight}
                            width={editorWidth}
                        />
                    </div>
                    {children}
                </div>
            );
        }
    }

    return (
        <div>
            <Route exact path={path} component={Wrapper} />
        </div>
    );
}

ExampleRouteWrapper.defaultProps = {
    editorWidth: '800px',
    editorHeight: '150px'
};

const mapDispatchToProps = (dispatch: *): PropsType => bindActionCreators({
}, dispatch);

export default connect(
    null,
    mapDispatchToProps
)(ExampleRouteWrapper);



// WEBPACK FOOTER //
// ./src/routeComponents/ExampleRouteWrapper/exampleRouteWrapper.js